import loadable from '@loadable/component';
export const manifest = {
  AnalyticsEventSender: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "AnalyticsEventSender";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "AnalyticsEventSender" */
          './analytics-event-sender'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./analytics-event-sender");
            }

            return eval('require.resolve')("./analytics-event-sender");
          }

        }, {
          resolveComponent: m => m.AnalyticsEventSender
        })
      }
    }
  },
  'AnalyticsEventSender.OnMount': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "AnalyticsEventSenderOnMount";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "AnalyticsEventSenderOnMount" */
          './analytics-event-sender-on-mount'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./analytics-event-sender-on-mount");
            }

            return eval('require.resolve')("./analytics-event-sender-on-mount");
          }

        }, {
          resolveComponent: m => m.AnalyticsEventSenderOnMount
        })
      }
    }
  }
};